(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('LotDetailController', LotDetailController);

    LotDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'LotDTO', 'Contract','Principal',
        'ToastrService', 'CommentCustomService', 'AttachmentCustomService', 'PDFExportService', 'MiscService'];

    function LotDetailController($scope, $rootScope, $stateParams, previousState, entity, LotDTO, Contract, Principal,
                                 ToastrService, CommentCustomService, AttachmentCustomService, PDFExportService, MiscService) {
        var vm = this;


        vm.lot = entity;
        var lotId = vm.lot.id;

        vm.updateLot = updateLot;
        vm.refreshLot = refreshLot;
        vm.downloadPDF = downloadPDF;
        vm.downloadAttachment = downloadAttachment;
        vm.switchUnitWeightType = switchUnitWeightType;
        vm.nl2br = MiscService.nl2br;

        getPrincipal();
        vm.isAgent = false;
        function getPrincipal() {
            Principal.identity().then(function(account) {
                vm.account = account;
                if(vm.account.company !== undefined && vm.account.company !== null) {
                    vm.isAgent = true;
                    vm.agentId = vm.account.company.id;
                }
            });
        }

        //placeholders for lazy stuff
        vm.commentList = [];
        vm.attachmentList = [];

        vm.unitWeightTypes = ['KG', 'LB', 'MT'];
        vm.selectedUnitWeightType = vm.lot.lotPurchWtType;

        resolveLazyStuff(lotId);

        function updateLot(activeTab) {
            var data = {
                heading: 'Edit ' + vm.lot.lotRef,
                route: 'lot.edit',
                id: lotId,
                param: {id: lotId, activeTab: activeTab}
            };
            $rootScope.$emit('handleEmit', data);
        }

        function refreshLot() {
            refetchLot(lotId);
            resolveLazyStuff(lotId);
        }

        function downloadPDF() {
            PDFExportService.downloadLotPDF(vm.lot.id).then(function (data, status, headers, config) {
                var file = new Blob([data.data], {type: 'application/pdf'});
                saveAs(file, vm.lot.lotRef + '.pdf');
            }, function (error) {
                if( error.status !== 404 ) {
                    ToastrService.error("Something went wrong: " + error.statusText , "Error!");
                }
            });
        }

        function downloadAttachment( attachment ) {
            AttachmentCustomService.downloadAttachment( attachment.id ).then( function( data, status, headers, config ) {
                var file = new Blob([data.data], {type: 'application/octet-stream'});
                saveAs(file, attachment.fileName );
            }, function( error ) {
                if( error.status !== 404 ) {
                    ToastrService.error( "Cannot download Attachment: " + error.statusText, "Error");
                }
            });
        }

        function refetchLot(id) {
            LotDTO.get({id: id}).$promise.then(function (data) {
                vm.lot = data;
                resetUnitWeightType();
                ToastrService.success( "Refreshed Lot", "Success!" );
            }, function (error) {
                if( error.status !== 404 ) {
                    ToastrService.error("Failed to refresh Lot: " + error.statusText, "Error!");
                }
            });
        }

        //resolve lazy stuff function
        function resolveLazyStuff(id) {
            resolveComments(id);
            resolveAttachments(id);
        }

        function resetUnitWeightType() {
            vm.selectedUnitWeightType = vm.lot.lotPurchWtType;
        }

        function switchUnitWeightType(option) {
            vm.selectedUnitWeightType = option;
        }

        /////////////////////////////////////////
        // RESOLVE FUNCTIONS
        /////////////////////////////////////////

        //resolve comments function
        function resolveComments(id) {
            CommentCustomService.returnCommentsByLot(id).then(function (data) {
                vm.commentList = data.data;
                if (vm.commentList.length > 0) {
                    vm.showComment = true;
                }
            }, function (error) {
                if (error.status !== 404) {
                    ToastrService.error("Failed to get Comments: " + error.statusText, "Error!");
                }
            });
        }

        //resolve attachments function
        function resolveAttachments(id) {
            AttachmentCustomService.returnAttachmentsByLot(id).then(function (data) {
                vm.attachmentList = data.data;
                if (vm.attachmentList.length > 0) {
                    vm.showAttachment = true;
                }
            }, function (error) {
                if (error.status !== 404) {
                    ToastrService.error("Failed to get Attachments: " + error.statusText, "Error!");
                }
            });
        }


        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('ccsTrApp:lotUpdate', function (event, result) {
            vm.lot = result;
        });
        $scope.$on('$destroy', unsubscribe);

        vm.getOrDash = function(val) {
            return (val && val !== null) ? val : '-';
        };

        vm.createTab = function (data) {
            $scope.$emit('handleEmit', data);
        };
    }
})();
